<template>
  <div>
    <div class="walk-wrap">
      <div class="card">
        <div class="row header">
          <h2>
            <img
              v-if="active"
              src="../static/img/DogRunning.gif"
              width="35px"
            />
            <img v-else src="../static/img/DogStatic.png" width="35px" />Balade
          </h2>
          <button
            class="btn"
            :class="active ? 'danger' : 'primary btn-walk'"
            @click="toggleWalk"
            :disabled="busy"
          >
            {{ active ? "Arrêter la balade" : "Démarrer une balade" }}
          </button>
        </div>

        <div class="block today-walk-block">
          <div class="label">Total du jour</div>
          <div
            class="today-walk-summary"
            aria-label="Résumé des balades du jour"
          >
            🕒 {{ compactDurationText(todayWalkSummary.totalMs) }} · 🐕‍🦺
            {{ todayWalkSummary.walkCount }} · 💦
            {{ todayWalkSummary.peeCount }} · 💩
            {{ todayWalkSummary.poopCount }}
          </div>
        </div>

        <!-- Dernière balade terminée -->
        <div v-if="!active" class="block">
          <div class="label">Dernière balade terminée</div>
          <div class="value">
            <div
              v-if="last"
              class="last-event last-event--clickable"
              role="button"
              tabindex="0"
              @click="openWalkEditor(last)"
              @keydown.enter.prevent="openWalkEditor(last)"
              @keydown.space.prevent="openWalkEditor(last)"
            >
              <div class="last-date">{{ lastWalkDateText(last) }}</div>
              <div class="last-time">
                {{ lastWalkRangeText(last) }}
              </div>
              <div class="needs-readonly">
                🕒 {{ durationText(last.start_ts, last.end_ts) }} &nbsp;•&nbsp;
                💦 {{ last.pee_count || 0 }} &nbsp;•&nbsp; 💩
                {{ last.poop_count || 0 }}
              </div>
              <!-- Photos de la dernière balade -->
              <div
                v-if="walkPhotos[last.id] && walkPhotos[last.id].length"
                class="photos-grid photos-grid--center"
              >
                <img
                  v-for="(p, idx) in walkPhotos[last.id]"
                  :key="p.id"
                  :src="`${photosUrl}/${p.filename}`"
                  class="photo-thumb"
                  @click.stop="openPhoto(walkPhotos[last.id], idx)"
                />
              </div>
            </div>
            <span v-else class="muted"
              >Aucune balade terminée pour l’instant</span
            >
          </div>
        </div>

        <!-- Balade en cours -->
        <div v-if="active" class="block">
          <div class="label">Balade en cours</div>
          <div class="value">
            <div class="last-event">
              <div class="active-duration">
                {{ elapsedText }}
              </div>
              <div class="last-time">
                {{ formatTimeShort(active.start_ts) }} → en cours
              </div>
              <!-- Photos de la balade en cours -->
              <div
                v-if="walkPhotos[active.id] && walkPhotos[active.id].length"
                class="photos-grid photos-grid--center"
              >
                <img
                  v-for="(p, idx) in walkPhotos[active.id]"
                  :key="p.id"
                  :src="`${photosUrl}/${p.filename}`"
                  class="photo-thumb"
                  @click.stop="openPhoto(walkPhotos[active.id], idx)"
                />
              </div>
            </div>
          </div>
        </div>

        <!-- Compteurs besoins -->
        <div v-if="active" class="needs-wrap">
          <button
            class="need-btn pee"
            :disabled="busy || !active"
            @click="addPee"
          >
            💦&nbsp;{{ active?.pee_count || 0 }}
          </button>
          <button
            class="need-btn poop"
            :disabled="busy || !active"
            @click="addPoop"
          >
            💩&nbsp;{{ active?.poop_count || 0 }}
          </button>
          <button
            class="need-btn photo"
            :disabled="busy || !active || uploadingPhoto"
            @click="openCamera"
          >
            {{ uploadingPhoto ? "⏳" : "📷" }}&nbsp;Photo
          </button>
          <input
            ref="photoInput"
            type="file"
            accept="image/*"
            capture="environment"
            style="display: none"
            @change="uploadPhoto"
          />
        </div>

        <!-- Historique -->
        <div class="history-wrap">
          <button class="btn ghost" @click="toggleHistory" :disabled="busy">
            <span class="chev" :class="{ open: showHistory }">▾</span>
            {{ showHistory ? "Historique" : "Historique" }}
          </button>

          <div v-show="showHistory" class="history-panel">
            <div v-if="walksSorted.length === 0" class="muted">
              Aucune donnée.
            </div>

            <div
              v-for="group in walksPage"
              :key="group.key"
              class="history-day"
            >
              <div
                class="history-day-header"
                role="button"
                tabindex="0"
                @click="toggleHistoryDay(group.key)"
                @keydown.enter.prevent="toggleHistoryDay(group.key)"
                @keydown.space.prevent="toggleHistoryDay(group.key)"
              >
                <div class="history-day-title">
                  <strong>{{ group.label }}</strong>
                </div>
                <div class="history-day-summary">
                  🕒 {{ compactDurationText(group.totalMs) }} · 🐕‍🦺
                  {{ group.walks.length }} · 💦 {{ group.peeCount }} · 💩
                  {{ group.poopCount }}
                </div>
              </div>

              <div
                v-for="w in group.walks"
                v-show="!isHistoryDayCollapsed(group.key)"
                :key="w.id"
                class="history-row"
                role="button"
                tabindex="0"
                @click="openWalkEditor(w)"
                @keydown.enter.prevent="openWalkEditor(w)"
                @keydown.space.prevent="openWalkEditor(w)"
              >
                <div class="info">
                  <div class="line">
                    <strong class="walk-time">{{
                      historyRangeText(w, group.key)
                    }}</strong>
                    <span class="walk-summary">
                      🕒 {{ compactDurationText(walkDurationMs(w)) }} · 💦
                      {{ w.pee_count || 0 }} · 💩 {{ w.poop_count || 0 }}
                    </span>
                  </div>
                  <!-- Photos de la balade -->
                  <div
                    v-if="walkPhotos[w.id] && walkPhotos[w.id].length"
                    class="photos-grid"
                  >
                    <img
                      v-for="(p, idx) in walkPhotos[w.id]"
                      :key="p.id"
                      :src="`${photosUrl}/${p.filename}`"
                      class="photo-thumb"
                      @click.stop="openPhoto(walkPhotos[w.id], idx)"
                    />
                  </div>
                </div>
              </div>
            </div>

            <!-- Pagination -->
            <div v-if="walksPageCount > 1" class="pagination">
              <button
                class="page-btn"
                :disabled="historyPage === 1"
                @click="goToPage(historyPage - 1)"
              >
                ‹
              </button>
              <span
                v-for="p in paginationPages"
                :key="typeof p === 'number' ? p : 'e' + p"
              >
                <span v-if="p === '...'" class="page-ellipsis">…</span>
                <button
                  v-else
                  class="page-btn"
                  :class="{ active: p === historyPage }"
                  @click="goToPage(p)"
                >
                  {{ p }}
                </button>
              </span>
              <button
                class="page-btn"
                :disabled="historyPage === walksPageCount"
                @click="goToPage(historyPage + 1)"
              >
                ›
              </button>
            </div>
          </div>
        </div>
        <!-- /Historique -->
      </div>
    </div>

    <!-- Carousel plein écran -->
    <div v-if="lightbox" class="lightbox" @click.self="lightbox = null">
      <button class="lb-close" @click.stop="lightbox = null">✕</button>
      <button
        v-if="lightbox.photos.length > 1"
        class="lb-arrow lb-prev"
        @click.stop="lightboxPrev"
      >
        ‹
      </button>
      <img :src="lightboxCurrentSrc" class="lightbox-img" @click.stop />
      <button
        v-if="lightbox.photos.length > 1"
        class="lb-arrow lb-next"
        @click.stop="lightboxNext"
      >
        ›
      </button>
      <div v-if="lightbox.photos.length > 1" class="lb-counter">
        {{ lightbox.index + 1 }} / {{ lightbox.photos.length }}
      </div>
    </div>

    <div v-if="editingWalk" class="edit-modal" @click.self="closeWalkEditor">
      <form class="edit-dialog" @submit.prevent="saveWalkEdit">
        <div class="edit-header">
          <h3>Modifier la balade</h3>
          <button type="button" class="edit-close" @click="closeWalkEditor">
            x
          </button>
        </div>

        <label class="edit-field">
          <span>Debut</span>
          <input v-model="editForm.start_ts" type="datetime-local" required />
        </label>

        <label class="edit-field">
          <span>Fin</span>
          <input v-model="editForm.end_ts" type="datetime-local" />
        </label>

        <div class="edit-counts">
          <div class="edit-counter pee">
            <span class="edit-counter-icon" aria-hidden="true">💦</span>
            <div class="edit-stepper" aria-label="Nombre de pipis">
              <button
                type="button"
                @click="changeEditCount('pee_count', -1)"
                :disabled="editForm.pee_count <= 0"
              >
                -
              </button>
              <strong>{{ editForm.pee_count }}</strong>
              <button type="button" @click="changeEditCount('pee_count', 1)">
                +
              </button>
            </div>
          </div>
          <div class="edit-counter poop">
            <span class="edit-counter-icon" aria-hidden="true">💩</span>
            <div class="edit-stepper" aria-label="Nombre de cacas">
              <button
                type="button"
                @click="changeEditCount('poop_count', -1)"
                :disabled="editForm.poop_count <= 0"
              >
                -
              </button>
              <strong>{{ editForm.poop_count }}</strong>
              <button type="button" @click="changeEditCount('poop_count', 1)">
                +
              </button>
            </div>
          </div>
        </div>

        <div class="edit-actions">
          <button
            type="button"
            class="btn danger edit-delete"
            :disabled="savingEdit"
            @click="deleteWalk"
          >
            Supprimer
          </button>
          <button type="button" class="btn ghost" @click="closeWalkEditor">
            Annuler
          </button>
          <button type="submit" class="btn primary" :disabled="savingEdit">
            {{ savingEdit ? "Enregistrement..." : "Enregistrer" }}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import api from "../api/api";
import { onRefresh, offRefresh } from "../utils/refresh";

export default {
  name: "WalkToggle",
  data() {
    return {
      active: null, // balade en cours (ou null)
      last: null, // dernière terminée
      busy: false,
      tick: 0,
      interval: null,

      // Historique
      showHistory: false,
      historyLoaded: false,
      walks: [],
      historyPage: 1,
      historyPageSize: 10,
      collapsedHistoryDays: {},

      // Photos
      walkPhotos: {}, // { [walkId]: [...photos] }
      uploadingPhoto: false,
      lightbox: null, // { photos: [], index: 0 }
      editingWalk: null,
      editForm: {
        start_ts: "",
        end_ts: "",
        pee_count: 0,
        poop_count: 0,
      },
      savingEdit: false,
    };
  },
  async created() {
    await this.refreshState();
    this.interval = setInterval(
      () => (this.tick = (this.tick + 1) % 1e9),
      1000
    );
    onRefresh(this.handleGlobalRefresh);
    window.addEventListener("keydown", this.onKeyDown);
  },
  beforeDestroy() {
    if (this.interval) clearInterval(this.interval);
    offRefresh(this.handleGlobalRefresh);
    window.removeEventListener("keydown", this.onKeyDown);
  },
  computed: {
    apiUrl() {
      return api.api;
    },
    photosUrl() {
      return api.photos;
    },
    elapsedText() {
      if (!this.active) return "—";
      this.tick;
      const start = new Date(this.active.start_ts).getTime();
      const now = Date.now();
      return this.msToHMS(now - start);
    },
    // Dernière (end_ts ou start_ts) en premier
    walksSorted() {
      const arr = (this.walks || []).slice();
      arr.sort((a, b) => {
        const ta = new Date(a.end_ts || a.start_ts).getTime();
        const tb = new Date(b.end_ts || b.start_ts).getTime();
        return tb - ta;
      });
      return arr;
    },
    todayWalkSummary() {
      this.tick;
      const todayKey = this.localDateKey(new Date());
      const byId = new Map();
      for (const walk of this.walks || []) {
        if (walk && walk.id != null) byId.set(walk.id, walk);
      }
      if (this.active && this.active.id != null)
        byId.set(this.active.id, this.active);

      const todayWalks = Array.from(byId.values()).filter(
        (walk) => this.localDateKey(walk.start_ts) === todayKey
      );

      return todayWalks.reduce(
        (acc, walk) => {
          acc.walkCount += 1;
          acc.totalMs += this.walkDurationMs(walk);
          acc.peeCount += walk.pee_count || 0;
          acc.poopCount += walk.poop_count || 0;
          return acc;
        },
        { walkCount: 0, totalMs: 0, peeCount: 0, poopCount: 0 }
      );
    },
    historyGroups() {
      this.tick;
      const groups = [];
      const byKey = {};
      for (const walk of this.walksSorted) {
        const key = this.localDateKey(walk.start_ts);
        if (!byKey[key]) {
          byKey[key] = {
            key,
            label: this.formatAccountingDateShort(walk.start_ts),
            totalMs: 0,
            peeCount: 0,
            poopCount: 0,
            walks: [],
          };
          groups.push(byKey[key]);
        }
        byKey[key].walks.push(walk);
        byKey[key].totalMs += this.walkDurationMs(walk);
        byKey[key].peeCount += walk.pee_count || 0;
        byKey[key].poopCount += walk.poop_count || 0;
      }
      return groups;
    },
    walksPageCount() {
      return Math.max(
        1,
        Math.ceil(this.historyGroups.length / this.historyPageSize)
      );
    },
    walksPage() {
      const start = (this.historyPage - 1) * this.historyPageSize;
      return this.historyGroups.slice(start, start + this.historyPageSize);
    },
    lightboxCurrentSrc() {
      if (!this.lightbox) return null;
      const p = this.lightbox.photos[this.lightbox.index];
      return `${this.photosUrl}/${p.filename}`;
    },
    paginationPages() {
      const total = this.walksPageCount;
      const cur = this.historyPage;
      if (total <= 7) {
        return Array.from({ length: total }, (_, i) => i + 1);
      }
      const pages = [1];
      if (cur > 3) pages.push("...");
      for (
        let i = Math.max(2, cur - 1);
        i <= Math.min(total - 1, cur + 1);
        i++
      ) {
        pages.push(i);
      }
      if (cur < total - 2) pages.push("...");
      pages.push(total);
      return pages;
    },
  },
  methods: {
    async handleGlobalRefresh() {
      try {
        await this.refreshState();
        if (this.showHistory) {
          await this.refreshHistory();
        }
      } catch {
        // silencieux
      }
    },
    async refreshState() {
      const [current, last, walks] = await Promise.all([
        axios.get(`${this.apiUrl}/walks/current`),
        axios.get(`${this.apiUrl}/walks/last`),
        axios.get(`${this.apiUrl}/walks`),
      ]);
      this.active = current.data || null;
      this.last = last.data || null;
      this.walks = Array.isArray(walks.data) ? walks.data : [];
      await this.loadCurrentWalkPhotos();
    },
    // photos de la balade en cours, ou de la dernière balade si aucune en cours
    async loadCurrentWalkPhotos() {
      const walk = this.active || this.last;
      if (!walk) return;
      const id = walk.id;
      try {
        const r = await axios.get(`${this.apiUrl}/walks/${id}/photos`);
        this.walkPhotos = { ...this.walkPhotos, [id]: r.data };
      } catch {
        // pas de photos affichées, sans bloquer le reste
      }
    },
    async refreshHistory() {
      await this.refreshState();
      this.historyLoaded = true;
      await this.loadPhotosForPage();
    },

    async loadPhotosForPage() {
      const visibleWalks = this.walksPage.reduce(
        (acc, group) => acc.concat(group.walks),
        []
      );
      const results = await Promise.all(
        visibleWalks.map((w) =>
          axios
            .get(`${this.apiUrl}/walks/${w.id}/photos`)
            .then((r) => ({ id: w.id, photos: r.data }))
        )
      );
      const map = { ...this.walkPhotos };
      for (const { id, photos } of results) map[id] = photos;
      this.walkPhotos = map;
    },

    isHistoryDayCollapsed(key) {
      return !!this.collapsedHistoryDays[key];
    },
    toggleHistoryDay(key) {
      this.collapsedHistoryDays = {
        ...this.collapsedHistoryDays,
        [key]: !this.collapsedHistoryDays[key],
      };
    },

    async goToPage(page) {
      if (page < 1 || page > this.walksPageCount || page === this.historyPage)
        return;
      this.historyPage = page;
      await this.loadPhotosForPage();
    },
    async toggleWalk() {
      try {
        this.busy = true;
        if (this.active) {
          await axios.post(`${this.apiUrl}/walks/end`);
        } else {
          await axios.post(`${this.apiUrl}/walks/start`);
        }
        await this.refreshState();
        if (this.showHistory) await this.refreshHistory();
      } catch (e) {
        alert(e?.response?.data?.error || "Erreur d’enregistrement");
      } finally {
        this.busy = false;
      }
    },
    async toggleHistory() {
      this.showHistory = !this.showHistory;
      if (this.showHistory) {
        this.historyPage = 1;
        if (!this.historyLoaded) {
          await this.refreshHistory();
        }
      }
    },
    formatTs(ts) {
      if (!ts) return "—";
      const d = new Date(ts);
      return d.toLocaleString("fr-FR", {
        weekday: "long",
        day: "2-digit",
        month: "long",
        hour: "2-digit",
        minute: "2-digit",
      });
    },
    formatDateShort(ts) {
      const d = new Date(ts);
      if (isNaN(d.getTime())) return "Date inconnue";
      const label = d.toLocaleDateString("fr-FR", {
        weekday: "long",
        day: "2-digit",
        month: "long",
      });
      return label.charAt(0).toUpperCase() + label.slice(1);
    },
    formatTimeShort(ts) {
      const d = new Date(ts);
      return d.toLocaleTimeString("fr-FR", {
        hour: "2-digit",
        minute: "2-digit",
      });
    },
    localDateKey(ts) {
      const d = new Date(ts);
      d.setHours(d.getHours() - 4);
      const y = d.getFullYear();
      const m = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      return `${y}-${m}-${day}`;
    },
    formatAccountingDateShort(ts) {
      const d = new Date(ts);
      d.setHours(d.getHours() - 4);
      return this.formatDateShort(d);
    },
    isSameLocalDay(a, b) {
      const da = new Date(a);
      const db = new Date(b);
      return (
        da.getFullYear() === db.getFullYear() &&
        da.getMonth() === db.getMonth() &&
        da.getDate() === db.getDate()
      );
    },
    walkDurationMs(walk) {
      const start = new Date(walk.start_ts).getTime();
      const end = walk.end_ts ? new Date(walk.end_ts).getTime() : Date.now();
      if (isNaN(start) || isNaN(end) || end < start) return 0;
      return end - start;
    },
    compactDurationText(ms) {
      if (!ms || ms < 0 || isNaN(ms)) return "0m";
      const totalMinutes = Math.max(1, Math.round(ms / 60000));
      const hours = Math.floor(totalMinutes / 60);
      const minutes = totalMinutes % 60;
      if (hours && minutes)
        return `${hours}h${minutes.toString().padStart(2, "0")}`;
      if (hours) return `${hours}h`;
      return `${minutes}m`;
    },
    historyRangeText(walk, groupKey) {
      const start = walk.start_ts;
      const end = walk.end_ts;
      const startDate = this.formatDateShort(start);
      const startTime = this.formatTimeShort(start);
      const startPrefix =
        groupKey === this.localDateKey(start)
          ? startTime
          : `${startDate} | ${startTime}`;
      if (!end) return `${startPrefix} - en cours`;

      const endTime = this.formatTimeShort(end);
      if (this.isSameLocalDay(start, end)) {
        return `${startPrefix} → ${endTime}`;
      }
      return `${startPrefix} → ${this.formatDateShort(end)} | ${endTime}`;
    },
    lastWalkDateText(walk) {
      return this.formatDateShort(walk.end_ts || walk.start_ts);
    },
    lastWalkRangeText(walk) {
      const start = walk.start_ts;
      const end = walk.end_ts;
      const startTime = this.formatTimeShort(start);
      if (!end) return `${startTime} → en cours`;
      const endTime = this.formatTimeShort(end);
      if (this.isSameLocalDay(start, end)) {
        return `${startTime} → ${endTime}`;
      }
      return `${this.formatDateShort(
        start
      )} | ${startTime} → ${this.formatDateShort(end)} | ${endTime}`;
    },
    msToHMS(ms) {
      if (ms < 0 || isNaN(ms)) return "—";
      const s = Math.floor(ms / 1000);
      const h = Math.floor(s / 3600);
      const m = Math.floor((s % 3600) / 60);
      const sec = s % 60;
      if (h > 0)
        return `${h}h${m.toString().padStart(2, "0")}m${sec
          .toString()
          .padStart(2, "0")}s`;
      return `${m}m${sec.toString().padStart(2, "0")}s`;
    },
    durationText(start, end) {
      const a = new Date(start).getTime();
      const b = new Date(end).getTime();
      return this.msToHMS(b - a);
    },
    toDatetimeLocal(ts) {
      if (!ts) return "";
      const d = new Date(ts);
      if (isNaN(d.getTime())) return "";
      const offsetMs = d.getTimezoneOffset() * 60000;
      return new Date(d.getTime() - offsetMs).toISOString().slice(0, 16);
    },
    datetimeLocalToISO(value) {
      if (!value) return null;
      const d = new Date(value);
      return isNaN(d.getTime()) ? null : d.toISOString();
    },
    openWalkEditor(walk) {
      this.editingWalk = walk;
      this.editForm = {
        start_ts: this.toDatetimeLocal(walk.start_ts),
        end_ts: this.toDatetimeLocal(walk.end_ts),
        pee_count: walk.pee_count || 0,
        poop_count: walk.poop_count || 0,
      };
    },
    closeWalkEditor() {
      if (this.savingEdit) return;
      this.editingWalk = null;
    },
    changeEditCount(field, delta) {
      const current = Number(this.editForm[field] || 0);
      this.editForm[field] = Math.max(0, current + delta);
    },
    async saveWalkEdit() {
      if (!this.editingWalk) return;
      const startISO = this.datetimeLocalToISO(this.editForm.start_ts);
      const endISO = this.datetimeLocalToISO(this.editForm.end_ts);
      if (!startISO) {
        alert("Debut de balade invalide");
        return;
      }
      if (this.editForm.end_ts && !endISO) {
        alert("Fin de balade invalide");
        return;
      }
      if (endISO && new Date(endISO).getTime() < new Date(startISO).getTime()) {
        alert("La fin doit etre apres le debut");
        return;
      }
      try {
        this.savingEdit = true;
        await axios.put(`${this.apiUrl}/walks/${this.editingWalk.id}`, {
          start_ts: startISO,
          end_ts: endISO,
          pee_count: Number(this.editForm.pee_count || 0),
          poop_count: Number(this.editForm.poop_count || 0),
        });
        this.editingWalk = null;
        await this.refreshState();
        if (this.showHistory) await this.refreshHistory();
      } catch (e) {
        alert(e?.response?.data?.error || "Erreur lors de la modification");
      } finally {
        this.savingEdit = false;
      }
    },
    async deleteWalk() {
      if (!this.editingWalk) return;
      const walk = this.editingWalk;
      const ok = confirm(
        `Supprimer la balade du ${this.formatDateShort(walk.start_ts).toLowerCase()} (${this.lastWalkRangeText(walk)}) ?` +
          (this.walkPhotos[walk.id] && this.walkPhotos[walk.id].length
            ? "\nSes photos seront aussi supprimées."
            : "")
      );
      if (!ok) return;
      try {
        this.savingEdit = true;
        await axios.delete(`${this.apiUrl}/walks/${walk.id}`);
        this.editingWalk = null;
        await this.refreshState();
        if (this.historyPage > this.walksPageCount)
          this.historyPage = this.walksPageCount;
        if (this.showHistory) await this.refreshHistory();
      } catch (e) {
        alert(e?.response?.data?.error || "Erreur lors de la suppression");
      } finally {
        this.savingEdit = false;
      }
    },
    async addPee() {
      if (!this.active) return;
      try {
        this.busy = true;
        await axios.post(`${this.apiUrl}/walks/pee`);
        await this.refreshState();
      } catch (e) {
        alert(e?.response?.data?.error || "Erreur d’enregistrement (pipi)");
      } finally {
        this.busy = false;
      }
    },

    async addPoop() {
      if (!this.active) return;
      try {
        this.busy = true;
        await axios.post(`${this.apiUrl}/walks/poop`);
        await this.refreshState();
      } catch (e) {
        alert(e?.response?.data?.error || "Erreur d’enregistrement (caca)");
      } finally {
        this.busy = false;
      }
    },

    openCamera() {
      this.$refs.photoInput.value = "";
      this.$refs.photoInput.click();
    },

    async uploadPhoto(event) {
      const file = event.target.files[0];
      if (!file || !this.active) return;
      try {
        this.uploadingPhoto = true;
        const form = new FormData();
        form.append("photo", file);
        const { data } = await axios.post(
          `${this.apiUrl}/walks/${this.active.id}/photos`,
          form,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );
        // Ajouter la photo localement sans tout recharger
        const existing = this.walkPhotos[this.active.id] || [];
        this.walkPhotos = {
          ...this.walkPhotos,
          [this.active.id]: [...existing, data],
        };
        // S’assurer que l’historique est visible avec la photo
        if (!this.showHistory) {
          this.showHistory = true;
          if (!this.historyLoaded) await this.refreshHistory();
        }
      } catch (e) {
        alert(
          e?.response?.data?.error || "Erreur lors de l’upload de la photo"
        );
      } finally {
        this.uploadingPhoto = false;
      }
    },

    openPhoto(photos, index) {
      this.lightbox = { photos, index };
    },
    lightboxPrev() {
      if (!this.lightbox) return;
      this.lightbox.index =
        (this.lightbox.index - 1 + this.lightbox.photos.length) %
        this.lightbox.photos.length;
    },
    lightboxNext() {
      if (!this.lightbox) return;
      this.lightbox.index =
        (this.lightbox.index + 1) % this.lightbox.photos.length;
    },
    onKeyDown(e) {
      if (e.key === "Escape" && this.editingWalk) {
        this.closeWalkEditor();
        return;
      }
      if (!this.lightbox) return;
      if (e.key === "ArrowLeft") this.lightboxPrev();
      else if (e.key === "ArrowRight") this.lightboxNext();
      else if (e.key === "Escape") this.lightbox = null;
    },
  },
};
</script>

<style scoped>
.btn-walk {
  background: #2da948 !important;
}

.walk-wrap {
  max-width: 640px;
  margin: 16px auto;
  padding: 0 12px;
}
.card {
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: 14px;
  box-shadow: 0 6px 20px rgba(2, 6, 23, 0.06);
  padding: 16px;
}

.row.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 2px;
}
.btn {
  border: 0;
  border-radius: 10px;
  padding: 8px 12px;
  cursor: pointer;
  color: #fff;
  transition: transform 80ms ease, opacity 120ms ease, background 120ms ease;
}
.btn.primary {
  background: var(--btn-primary-bg);
}
.btn.danger {
  background: #b91c1c;
}
.btn:hover {
  transform: translateY(-1px);
  opacity: 0.95;
}
.btn.ghost {
  background: transparent;
  color: var(--text);
  border: 1px solid var(--border);
}
.btn.ghost:hover {
  background: var(--surface-2);
}

.block {
  padding: 10px 0;
  border-top: 1px dashed var(--border);
}
.block:first-of-type {
  border-top: 0;
}
.label {
  font-size: 12px;
  color: var(--text-muted);
  margin-bottom: 4px;
}
.value {
  color: var(--text);
}
.today-walk-summary {
  color: var(--text-2);
  font-size: 13px;
  font-weight: 700;
  line-height: 1.35;
  text-align: center;
  white-space: nowrap;
}
.last-event {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3px;
  text-align: center;
}
.last-event--clickable {
  margin: -6px -8px;
  padding: 6px 8px;
  border-radius: 10px;
  cursor: pointer;
  transition: background 120ms ease, box-shadow 120ms ease;
}
.last-event--clickable:hover,
.last-event--clickable:focus-visible {
  background: var(--surface-2);
  box-shadow: inset 0 0 0 1px var(--border);
  outline: none;
}
.last-date {
  color: var(--text-2);
  font-size: 13px;
  font-weight: 700;
}
.last-time {
  color: var(--text);
  font-size: 17px;
  font-weight: 700;
  line-height: 1.2;
}
.last-detail {
  color: var(--text-2);
  font-size: 13px;
  font-weight: 700;
}
.active-duration {
  color: var(--text);
  font-size: 22px;
  font-weight: 600;
  line-height: 1.2;
}
.muted {
  color: var(--text-muted);
}

.inline {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: baseline;
}
.sep {
  color: var(--text-faint);
}

/* Historique */
.history-wrap {
  margin-top: 12px;
  display: flex;
  flex-direction: column;
}
.chev {
  margin-left: 6px;
  display: inline-block;
  transition: transform 0.15s ease;
  transform: rotate(-90deg);
}
.chev.open {
  transform: rotate(0deg);
}

.history-panel {
  margin-top: 8px;
  border: 1px solid var(--border-2);
  border-radius: 10px;
  background: var(--surface);
  padding: 0;
  overflow: hidden;
}

.pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 4px;
  margin-top: 10px;
  padding-top: 8px;
  border-top: 1px dashed var(--border);
}

.page-btn {
  min-width: 30px;
  height: 30px;
  padding: 0 6px;
  border: 1px solid var(--border);
  border-radius: 6px;
  background: var(--surface);
  color: var(--text-2);
  cursor: pointer;
  font-size: 13px;
  transition: background 120ms ease;
}
.page-btn:hover:not(:disabled) {
  background: var(--surface-hover);
}
.page-btn:disabled {
  opacity: 0.4;
  cursor: default;
}
.page-btn.active {
  background: var(--btn-primary-bg);
  color: #fff;
  border-color: #111827;
}
.page-ellipsis {
  color: var(--text-faint);
  font-size: 13px;
  padding: 0 2px;
  line-height: 30px;
}

.history-day {
  overflow: hidden;
  margin-bottom: 0;
  border-bottom: 2px solid var(--border-2);
  background: var(--surface);
}
.history-day:last-of-type {
  margin-bottom: 0;
  border-bottom: 0;
}
.history-day-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 10px 11px;
  background: var(--surface-2);
  border-radius: 0;
  cursor: pointer;
  text-align: center;
  transition: background 120ms ease;
}
.history-day-header:hover,
.history-day-header:focus-visible {
  background: var(--surface-hover);
  outline: none;
}
.history-day-title {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 0;
}
.history-day-title strong {
  color: var(--text);
  font-size: 13px;
}
.history-day-summary {
  color: var(--text-2);
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
}

.history-row {
  padding: 8px 11px;
  border-top: 1px dashed var(--border-2);
  cursor: pointer;
  transition: background 120ms ease, box-shadow 120ms ease;
}
.history-row:hover,
.history-row:focus-visible {
  background: var(--surface-2);
  box-shadow: inset 3px 0 0 #10b981;
  outline: none;
}
.history-row:last-child {
  padding-bottom: 9px;
}

.info .line {
  display: grid;
  grid-template-columns: minmax(0, 1fr) max-content;
  align-items: center;
  gap: 8px;
  color: var(--text);
}
.walk-time {
  min-width: 0;
  font-size: 14px;
  line-height: 1.2;
  white-space: nowrap;
}
.walk-summary {
  color: var(--text-2);
  font-size: 12px;
  font-weight: 700;
  line-height: 1.2;
  white-space: nowrap;
}

.needs-wrap {
  display: flex;
  justify-content: center;
  gap: 12px;
  margin: 6px 0 10px;
}
.need-btn {
  border: 0;
  border-radius: 999px;
  padding: 8px 14px;
  cursor: pointer;
  color: var(--text);
  background: var(--chip-bg);
  border: 1px solid var(--border);
  transition: transform 80ms ease, background 120ms ease, opacity 120ms ease;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}
.need-btn:hover {
  transform: translateY(-1px);
  background: var(--surface);
}
.need-btn:disabled {
  opacity: 0.6;
  cursor: default;
}

.need-btn.pee .badge {
  background: #dbeafe;
  color: #1e3a8a;
  border-color: #bfdbfe;
}
.need-btn.poop .badge {
  background: #fde68a;
  color: #92400e;
  border-color: #fcd34d;
}

.badge {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 999px;
  border: 1px solid var(--border);
  font-size: 12px;
  line-height: 1;
}

.needs-readonly {
  margin-top: 4px;
  color: var(--text-2);
  font-size: 13px;
}

.need-btn.photo {
  background: #f0fdf4;
  border-color: #bbf7d0;
}

.photos-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 7px;
}
.photos-grid--center {
  justify-content: center;
}

.photo-thumb {
  width: 52px;
  height: 52px;
  object-fit: cover;
  border-radius: 8px;
  border: 1px solid var(--border-2);
  cursor: pointer;
  transition: transform 100ms ease, box-shadow 100ms ease;
}
.photo-thumb:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 14px rgba(15, 23, 42, 0.14);
}

@media (max-width: 460px) {
  .history-day-title {
    flex-wrap: wrap;
  }
  .info .line {
    gap: 6px;
  }
  .walk-time {
    line-height: 1.35;
  }
  .walk-summary {
    font-size: 11px;
  }
  .photo-thumb {
    width: 50px;
    height: 50px;
  }
}

.lightbox {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  user-select: none;
}
.lightbox-img {
  max-width: calc(100vw - 100px);
  max-height: 90vh;
  border-radius: 8px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
  object-fit: contain;
}
.lb-close {
  position: absolute;
  top: 14px;
  right: 16px;
  background: rgba(255, 255, 255, 0.15);
  border: none;
  color: #fff;
  font-size: 18px;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 120ms ease;
}
.lb-close:hover {
  background: rgba(255, 255, 255, 0.3);
}
.lb-arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(255, 255, 255, 0.15);
  border: none;
  color: #fff;
  font-size: 28px;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 120ms ease;
  line-height: 1;
}
.lb-arrow:hover {
  background: rgba(255, 255, 255, 0.3);
}
.lb-prev {
  left: 12px;
}
.lb-next {
  right: 12px;
}
.lb-counter {
  position: absolute;
  bottom: 18px;
  left: 50%;
  transform: translateX(-50%);
  color: rgba(255, 255, 255, 0.75);
  font-size: 13px;
  background: rgba(0, 0, 0, 0.4);
  padding: 3px 10px;
  border-radius: 999px;
}

.edit-modal {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.48);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  z-index: 9998;
  overflow-y: auto;
}
.edit-dialog {
  width: min(420px, calc(100vw - 32px));
  max-height: calc(100dvh - 32px);
  overflow-x: hidden;
  overflow-y: auto;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: 10px;
  box-shadow: 0 20px 60px rgba(15, 23, 42, 0.22);
  padding: 16px;
  box-sizing: border-box;
}
.edit-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}
.edit-header h3 {
  margin: 0;
  color: var(--text);
  font-size: 18px;
}
.edit-close {
  width: 32px;
  height: 32px;
  border: 1px solid var(--border);
  border-radius: 50%;
  background: var(--surface);
  color: var(--text-2);
  cursor: pointer;
}
.edit-field {
  display: flex;
  flex-direction: column;
  gap: 5px;
  margin-bottom: 10px;
  color: var(--text-2);
  font-size: 13px;
  min-width: 0;
}
.edit-field input {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
  border: 1px solid var(--border);
  border-radius: 8px;
  padding: 9px 10px;
  color: var(--text);
  font-size: 14px;
  -webkit-appearance: none;
  appearance: none;
}
.edit-counts {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  margin-top: 2px;
}
.edit-counter {
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 7px;
  border: 1px solid var(--border);
  border-radius: 8px;
  padding: 8px;
  background: var(--surface);
}
.edit-counter.pee {
  background: #eff6ff;
  border-color: #bfdbfe;
}
.edit-counter.poop {
  background: #fffbeb;
  border-color: #fde68a;
}
.edit-counter-icon {
  flex: 0 0 auto;
  font-size: 20px;
  line-height: 1;
}
.edit-stepper {
  min-width: 0;
  flex: 1 1 auto;
  display: grid;
  grid-template-columns: 34px minmax(24px, 1fr) 34px;
  align-items: center;
  gap: 4px;
}
.edit-stepper button {
  width: 34px;
  height: 34px;
  border: 1px solid rgba(15, 23, 42, 0.1);
  border-radius: 50%;
  background: var(--surface);
  color: var(--text);
  cursor: pointer;
  font-size: 18px;
  font-weight: 700;
  line-height: 1;
}
.edit-stepper button:disabled {
  opacity: 0.35;
  cursor: default;
}
.edit-stepper strong {
  min-width: 0;
  text-align: center;
  color: var(--text);
  font-size: 18px;
  line-height: 1;
}
.edit-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 6px;
}
/* bouton de suppression calé à gauche, loin de « Enregistrer » */
.edit-delete {
  margin-right: auto;
}

@media (max-width: 460px) {
  .edit-modal {
    align-items: flex-start;
    padding: max(12px, env(safe-area-inset-top)) 12px
      max(12px, env(safe-area-inset-bottom));
  }
  .edit-dialog {
    width: 100%;
    max-height: calc(100dvh - 24px);
    padding: 14px;
  }
  .edit-header h3 {
    font-size: 17px;
  }
  .edit-field input {
    font-size: 16px;
    padding: 10px 8px;
  }
  .edit-counts {
    gap: 8px;
  }
  .edit-counter {
    padding: 7px;
    gap: 7px;
  }
  .edit-stepper {
    grid-template-columns: 30px minmax(20px, 1fr) 30px;
  }
  .edit-stepper button {
    width: 30px;
    height: 30px;
  }
  .edit-actions {
    flex-wrap: wrap;
  }
}
</style>
